import script from "./BaseCardSection.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseCardSection.vue?vue&type=script&setup=true&lang=js"

import "./BaseCardSection.vue?vue&type=style&index=0&id=3a259fb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a259fb6"]])

export default __exports__